function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C7.435 1 3.75 4.559 3.75 8.967c0 5.46 7.37 13.467 7.706 13.79a.732.732 0 001.088 0c.335-.323 7.706-8.33 7.706-13.79C20.25 4.599 16.523 1 12 1z",
  fill: "#FF6C0E"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.126 10.405c0 .48-.412.868-.921.868a.972.972 0 01-.316-.052",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.38 12.742l.816.81 1.633-1.62c.417-.393.671-.932.671-1.532 0-.945-.64-1.75-1.536-2.048M6.874 10.405c0 .48.412.868.921.868.111 0 .217-.018.316-.052",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.62 12.742l-.816.81-1.633-1.62A2.094 2.094 0 015.5 10.4c0-.945.641-1.75 1.536-2.048",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.107 12.27a23.922 23.922 0 01-1.884 2.28.467.467 0 01-.699-.013c-.928-1.07-3.424-4.161-3.424-6.442C8.1 5.833 9.85 4 12.01 4c2.017 0 3.678 1.599 3.889 3.652m-.747 2.958c.126-.24.242-.48.343-.719m.362-1.15c-.013.071-.029.143-.046.214",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.515 7.174c-.116-.1-.324-.1-.324-.1s-.092-.3-.37-.4c-.115-.051-.208-.051-.277-.051-.046 0-.07.05-.046.1 0 .05.023.1.046.15.023.026.046.076.092.1.14.126.209.076.324.126.093.025.116.1.116.1s-.023-.05-.116-.075c-.023 0-.07-.025-.092-.025-.093 0-.185 0-.278-.1a.189.189 0 01-.092-.1s-.023-.026-.023 0c-.046 0-.07.025-.046.075.023.05.092.125.184.175a.59.59 0 00.278.05c.07.025.115.075.115.075l-.046.1c-.023.075-.023.15-.023.15s-.763-.275-1.34-.45c-.972-.326-1.665.45-2.104 1.002-.763 1.001-1.318.776-1.503.7-.023 0-.07 0-.07.05 0 .026 0 .05.024.05.555.376 1.086.201 1.895-.45.486-.4.763-.376.763-.376 0 .652.324.526.37 1.152.023.351-.092.601-.208.827-.046.075-.023.15.046.225.185.2.67.701.648 1.052 0 .025.023.05.046.05l.115.05c.047.025.116-.025.116-.1 0-.15-.092-.45-.3-.751-.301-.426-.278-.626-.024-.927.208-.25.44-.45.509-.901.07-.401-.116-.677-.208-.802 0-.025 0 0 0 0 .07.05.185.15.254.326.07.175.07.35.07.35.161 0 .37-.075.485-.1.046-.025.092.025.07.075a.573.573 0 01-.232.326c-.023.025-.046.05-.046.1l-.023.125c0 .05.046.1.092.075a.988.988 0 00.347-.325c.092-.175.139-.326.162-.426.023-.075.046-.15.092-.2.07-.075.162-.2.324-.35.07-.076.416.024.508-.026.047-.05.093-.2.093-.2-.046-.05-.231-.35-.393-.501z",
  fill: "#FFF0E7"
});
function SvgMarkerBoth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "/img/markerBoth.svg";
export { SvgMarkerBoth as ReactComponent };